import { Page } from '../../models/page.model';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { Utils } from '../../utils';

@Injectable({ providedIn: 'root' })
export class UserListResolver implements Resolve<Page<User>> {

    constructor(private userService: UserService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Page<User>>
        | Promise<Page<User>> | Page<User> {

        const params = this.prepareParams();
        return this.userService.getUserList(params);
    }

    private prepareParams() {
        let params = new HttpParams();

        this.userService.defaultSort.forEach( param => {
            params = params.append('sort', [param.paramName, param.sortDirection].join(','));
        });

        params = params.append('page', Utils.defaultFirstPage.toString());
        params = params.append('size', Utils.defaultPageSize.toString());

        return params;
    }
}
